<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-2.5">
        <h1 class="text-[26px] font-bold text-ink -tracking-[0.03em] m-0">Endorsing bodies</h1>
        <span v-if="bodies" class="bg-[#f0eef5] text-primary text-[13px] font-semibold py-0.5 px-2.5 rounded-full">{{ bodies.length }}</span>
      </div>
      <a href="#" @click.prevent="openEditModal(false)" class="bg-ink text-white text-sm font-medium py-2.5 px-6 rounded-full no-underline transition-all duration-200 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:text-white hover:no-underline hover:shadow-[0_4px_12px_rgba(0,0,0,0.07)]">
        + Add body
      </a>
    </div>

    <loader v-if="isLoading"></loader>

    <div v-if="!isLoading && bodies && bodies.length === 0" class="flex flex-col items-center py-[60px] px-5 text-muted">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
      <p class="text-sm text-muted mt-4 mb-0">No endorsing bodies yet</p>
      <a href="#" @click.prevent="openEditModal(false)" class="text-sm font-semibold text-primary no-underline mt-2 hover:no-underline">+ Add your first body</a>
    </div>

    <div v-if="bodies && bodies.length > 0" class="flex flex-col gap-2">
      <div
        v-for="body in bodies"
        :key="body.id"
        class="bg-white border border-black/6 rounded-[20px] shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-[box-shadow,border-color] duration-200 hover:border-black/8 hover:shadow-[0_4px_12px_rgba(0,0,0,0.07)]"
        :class="{ 'opacity-45': body.isActive === false }">
        <router-link :to="{ name: 'admin-body', params: { id: body.slug }}" class="flex items-center justify-between py-4 px-5 no-underline text-inherit hover:no-underline hover:text-inherit">
          <div class="flex items-center gap-3.5 min-w-0">
            <img v-if="body.logo" class="w-11 h-11 object-contain shrink-0" :src="`/static/images/${body.logo}`" :alt="body.title" width="44">
            <div class="flex flex-col min-w-0">
              <span class="text-[15px] font-semibold text-ink leading-tight">{{ body.title }}</span>
              <span v-if="body.shortDescription" class="text-[13px] text-muted mt-0.5 whitespace-nowrap overflow-hidden text-ellipsis">{{ body.shortDescription }}</span>
            </div>
          </div>

          <div class="flex items-center gap-4 shrink-0">
            <div class="flex gap-2">
              <span v-if="body.isActive" class="text-xs font-medium py-0.5 px-2.5 rounded-full whitespace-nowrap bg-[#e2f3d1] text-[#2d7a0e]">Active</span>
              <span v-else class="text-xs font-medium py-0.5 px-2.5 rounded-full whitespace-nowrap bg-[#fef2f2] text-[#e53935]">Inactive</span>
              <span v-if="body.isFree" class="text-xs font-medium py-0.5 px-2.5 rounded-full whitespace-nowrap bg-[#fffaf5] text-[#8a6d3b]">Free</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-muted"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </router-link>
      </div>
    </div>

    <body-add ref="modal" :item="editBody" @update="update"></body-add>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BodyAdd from './Includes/BodyAddModal'

export default {
  name: 'bodies',
  components: {
    bodyAdd: BodyAdd
  },
  data () {
    return {
      editBody: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      bodies: state => state.managers.bodies,
      user: state => state.auth.user
    })
  },
  methods: {
    openEditModal () {
      this.editBody = null
      this.$refs.modal.showModal()
    },
    update () {
      this.$refs.modal.hideModal()
    }
  },
  created () {
    this.isLoading = true
    this.$store.dispatch('GET_BODIES').then(() => {
      this.isLoading = false
    }).catch((error) => {
      this.isLoading = false
      console.error('Failed to load bodies:', error)
      if (error.code === 'permission-denied') {
        this.$router.push({ name: 'login' })
      }
    })

    if (this.user && !this.user.isAdmin) {
      this.$router.push({ name: 'components' })
    }
  }
}
</script>
